import React from 'react';
import { Link } from 'react-router-dom';
import { Award, BookOpen, Heart, Star } from 'lucide-react';

const AboutPreview = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-charcoal via-brand-moody/30 to-brand-charcoal" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="aspect-[4/5] rounded-sm overflow-hidden border-gold-glow">
              <img
                src="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Wedding ceremony"
                className="w-full h-full object-cover"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/80 via-transparent to-transparent" />
            </div>
            
            {/* Floating credential badge */}
            <div className="absolute -bottom-6 -right-6 bg-brand-charcoal border border-gold-500/30 p-6 rounded-sm shadow-2xl">
              <div className="flex items-center space-x-3">
                <Award className="w-10 h-10 text-gold-500" />
                <div>
                  <p className="text-warm-100 font-serif text-lg">Ordained Minister</p>
                  <p className="text-warm-100/60 text-sm">Licensed & Certified</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <p className="text-gold-500 tracking-[0.3em] uppercase text-sm mb-4">
              Meet Your Officiant
            </p>
            <h2 className="text-4xl md:text-5xl font-script text-gold-500 mb-2">
              Keeper Of The Fiyah
            </h2>
            <p className="text-warm-100/60 tracking-[0.2em] uppercase text-sm mb-8">
              Drip N Fiyah Ministry
            </p>

            <p className="text-warm-100/80 text-lg leading-relaxed mb-6">
              With a heart devoted to celebrating love in all its forms, I bring warmth, 
              reverence, and personalized attention to every ceremony I officiate.
            </p>
            <p className="text-warm-100/70 leading-relaxed mb-8">
              Each union is a sacred moment—a testament to the power of love and commitment. 
              My calling is to honor that moment with grace, ensuring your ceremony reflects 
              the unique bond you share.
            </p>

            {/* Credentials */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-start space-x-3">
                <BookOpen className="w-5 h-5 text-gold-500 mt-1" />
                <div>
                  <p className="text-warm-100 font-medium">Ordained Minister</p>
                  <p className="text-warm-100/60 text-sm">Legally authorized</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Heart className="w-5 h-5 text-gold-500 mt-1" />
                <div>
                  <p className="text-warm-100 font-medium">All Faiths Welcome</p>
                  <p className="text-warm-100/60 text-sm">Inclusive ceremonies</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Star className="w-5 h-5 text-gold-500 mt-1" />
                <div>
                  <p className="text-warm-100 font-medium">Personalized Service</p>
                  <p className="text-warm-100/60 text-sm">Custom ceremonies</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Award className="w-5 h-5 text-gold-500 mt-1" />
                <div>
                  <p className="text-warm-100 font-medium">Travel Available</p>
                  <p className="text-warm-100/60 text-sm">Your location</p>
                </div>
              </div>
            </div>

            <Link
              to="/about"
              className="btn-gold text-sm tracking-[0.2em] uppercase"
              data-testid="learn-more-about-btn"
            >
              Read My Story
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
